import React, { useEffect, useState, useCallback, useRef } from 'react'
import useResourceList from '../../custom-hooks/useResourceList'
import { BasicGridModule, CustomSelect, Loading, StringList, Concat, ModalContainer } from '@scrippsproduct/scripps-external-component-library'
import { subscribe } from '@scrippsproduct/scripps-external-component-library/dist/utils/events'
import { getMinutesFromStr } from '@scrippsproduct/scripps-external-component-library/dist/utils/helpers'

import './../../scss/EpisodeGuide.scss'

function EpisodeGuide({ slug = '' }) {
    const [seasons, setSeasons] = useState([])
    const [episodes, setEpisodes] = useState([])
    const modalOpenEl = useRef(null)
    const lastVideo = useRef(null)
    const episodesBySeason = useResourceList({
        cacheName: `episodes:${slug}`,
        resourceName: 'episodes',
        queryVars: {
            slug: `slug = '${slug}'`,
        }
    })

    /**
     * Handle click events from child components
     * @param {object} eventDetails 
     */
    const handleClicks = eventDetails => {
        if (eventDetails.type === 'play-video') {   
            modalOpenEl.current = eventDetails.target
            modalOpenEl.current.setAttribute('id', 'opened-modal')

            const modalComponentProps = {
                bcId: eventDetails.resourceId,
                autoplay: true,
            }

            const event = new CustomEvent('scripps:modal:change',  {
                detail: {
                    componentProps: {
                        ...modalComponentProps,
                    },
                    forceOpen: (lastVideo.current === eventDetails.resourceId) ? false : true,
                }
            })
            document.getElementById('modal-container').dispatchEvent(event)
            document.querySelector('body').style.overflow = 'hidden'
        }
    }  

    const onModalClose = () => {
        document.querySelector('body').style.overflow = 'auto'

        return true
    }

    const handleSeaonSelected = useCallback(detail => {
        const episdoesSort = (a,b) => {
            if (a.episodeNumber === b.episodeNumber) return 0

            return (a.episodeNumber > b.episodeNumber) ? 1 : -1
        }
        const season = seasons.find(s => s.id === detail.value)

        if (season)  {
            setEpisodes(season.episodes.sort(episdoesSort))
        } else {
            setEpisodes(seasons[0].episodes.sort(episdoesSort))
        }
    }, [seasons])

    useEffect(() => {
        if (episodesBySeason.data !== undefined && episodesBySeason.isSuccess) { 
            const orderedSeasons = episodesBySeason.data.SeriesList.items[0].seasons.filter(item => item.seasonNumber !== 0).sort((a, b) => {
                if (a.seasonNumber === b.seasonNumber) return 0

                return (a.seasonNumber > b.seasonNumber) ? 1 : -1
            })
            setSeasons(orderedSeasons)
        }
    }, [episodesBySeason.isSuccess, episodesBySeason.data])

    useEffect(() => {
        if (seasons.length) {
            subscribe('scripps:customselect:selected', e => {
                handleSeaonSelected(e.detail)
            })
            handleSeaonSelected({value: seasons[0].id})
        }
    }, [seasons, handleSeaonSelected])

    return <episode-guide>
        <div className="episode-guide__header">
            <h2 className="h2">Episode Guide</h2>
            <div className='season-selector-wrapper'>
                <span>More Seasons:</span> 
                { (seasons.length > 0) && <CustomSelect 
                    name="season-selector" 
                    showValidation={false} 
                    placeholder={'Select Season'} 
                    expandIconType={'chevron'}
                    options={seasons.map(item => {
                        return {
                            label: `Season ${item.seasonNumber}`,
                            value: item.id,
                        }
                    })}
                /> }
            </div>
        </div>
        { ((episodesBySeason.isSuccess && !episodesBySeason.isFetching) && seasons.length > 0) && <BasicGridModule 
            itemsPerRow={3}
            classname={`episodes-grid`}
            gap={`2rem 2.5rem`}
            title={``}
            itemComponentPath={`block/ImageCard`}
            customClicksHandler={handleClicks}
            items={episodes.map(item => {
                return {
                    id: item.id,
                    image: {
                        url: item?.featuredImage?.image?.sizes?.[0]?.srcSets?.[1]?.src,
                        altText: '',
                        aspectRatio: 543/305,
                        sources: [
                            {
                                srcsets:  [
                                    `${item?.featuredImage?.image?.sizes?.[0]?.srcSets?.[1]?.src}`,
                                    `${item?.featuredImage?.image?.sizes?.[0]?.srcSets?.[3]?.src} 2x`,
                                    `${item?.featuredImage?.image?.sizes?.[0]?.srcSets?.[5]?.src} 3x`
                                ],
                                media: 'min-width: 1px'
                            },
                        ],
                    },
                    title: `Episode ${item.episodeNumber}: ${item.title}`,
                    content: <Concat list={[
                        `<p>${item.description}</p>`,
                        <StringList list={(item.brightcoveID) 
                            ? [
                                (item?.elementLength !== null) ? getMinutesFromStr(item?.elementLength) : `60 MIN`,
                                item?.contentRating,
                                '&nbsp;',
                            ]
                            : [
                                (item?.elementLength !== null) ? getMinutesFromStr(item?.elementLength) : `60 MIN`,
                                item?.contentRating,
                            ] 
                        } separatorType={'pipe'} />,
                    ]} />,
                    clampContentLines: true,
                    cta: (item.brightcoveID) ? {
                        label: 'Watch Episode',
                        type: 'play-video',
                        href: '',
                        relatedResourceId: item.brightcoveID,
                        position: 'inline',
                    } : { 
                        label: '', 
                        href: '', 
                        type: '', 
                        relatedResourceId: '', 
                        position: 'end' 
                    },
                }
            })} 
        /> }
        { (episodesBySeason.isLoading || episodesBySeason.isFetching ) && <Loading topOffset={`5rem`} />}
        <ModalContainer forceOpen={false} onModalClose={onModalClose} />
    </episode-guide>
}

export default EpisodeGuide